import React from "react"
import ReactDOM from "react-dom"
import InfoBanner from "./info-banner-component"

export default class LinkButtonsBannerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<InfoBanner {...self.modelJson} />, self.elem)
  }
}
